import { Component, OnDestroy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { WindowScrollService } from 'src/app/services/window-scroll.service';
import { ChangelogService } from 'src/app/services/changelog.service';
import { shCheck, shXmark } from '@beyondtrust/shield-icons';

// Data Sources
import {
	comboBoxStylesDefaultTheme,
	comboBoxStylesDarkTheme,
	comboBoxStylesTypography,
	comboBoxStylesStructure,
} from './combo-box-styles';

@Component({
	selector: 'app-combo-box',
	templateUrl: './combo-box.component.html',
	styleUrls: ['./combo-box.component.less'],
})
export class ComboBoxComponent implements OnDestroy {
	public currLive = 'default';
	public currTheme = 'default';
	public currVisible = 'overview';

	// Imported Style Variables
	public stylesDefault = comboBoxStylesDefaultTheme;
	public stylesDark = comboBoxStylesDarkTheme;
	public stylesTypography = comboBoxStylesTypography;
	public stylesStructure = comboBoxStylesStructure;

	public pageSubNavData = [
		{
			name: 'Overview',
			value: 'overview',
			empty: false,
			children: [],
		},
		{
			name: 'Live example',
			value: 'example',
			empty: false,
			children: [],
		},
		{
			name: 'Developer resources',
			value: 'dev',
			empty: true,
			children: [],
		},
		{
			name: 'Styles',
			value: 'styles',
			empty: false,
			children: [],
		},
		{
			name: 'Behaviors',
			value: 'behaviors',
			empty: false,
			children: [
				{
					name: 'A',
					value: 'A',
				},
				{
					name: 'B',
					value: 'B',
				},
			],
		},
		{
			name: 'Variations',
			value: 'variations',
			empty: false,
			children: [
				{
					name: 'A',
					value: 'A',
				},
				{
					name: 'B',
					value: 'B',
				},
			],
		},
		{
			name: 'Usage guidelines',
			value: 'usage',
			empty: false,
			children: [
				{
					name: 'A',
					value: 'A',
				},
				{
					name: 'B',
					value: 'B',
				},
				{
					name: 'C',
					value: 'C',
				},
				{
					name: 'D',
					value: 'D',
				},
				{
					name: 'E',
					value: 'E',
				},
			],
		},
		{
			name: 'Placeholder',
			value: 'placeholder',
			empty: false,
			children: [],
		},
		{
			name: 'Resources',
			value: 'resources',
			empty: false,
			children: [],
		},
		{
			name: 'Related',
			value: 'related',
			empty: false,
			children: [],
		},
		{
			name: 'Revision history',
			value: 'history',
			empty: false,
			children: [],
		},
	];

	constructor(
		private viewportScroller: ViewportScroller,
		private router: Router,
		private clipboardService: ClipboardService,
		public changelogService: ChangelogService,
		scrollService: WindowScrollService
	) {
		scrollService.sectionChange.subscribe((currentSection: string) => {
			this.onVisible(currentSection);
		});
	}

	ngOnDestroy() {
		document.documentElement.setAttribute('data-theme', 'light');
	}
	
	public onAnchorClick(elementId: string): void {
		this.viewportScroller.scrollToAnchor(elementId);
	}

	public changeCurrLive(event): void {
		this.currLive = event.target.value;
	}

	public changeCurrTheme(event): void {
		this.currTheme = event.target.value;
	}

	public copyToClipboard(newValue): void {
		this.clipboardService.createClipboard({
			value: newValue,
			type: 'url',
		});
	}

	public onVisible(section: string): void {
		this.currVisible = section;
	}

	public comboBoxHTML = `Code Example Content (found at bottom of .ts file)`;
}
